/* import __COLOCATED_TEMPLATE__ from './data-type-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface DataTypeSelectItemArgs {
  item: {
    text: string;
    icon: InterfaceIconName;
    value: string;
  };
}

const DataTypeSelectItem = templateOnlyComponent<DataTypeSelectItemArgs>();

export default DataTypeSelectItem;

// Add type declarations for Glint
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::DataTypeSelectItem': typeof DataTypeSelectItem;
    'workflows/graph-editor/node-items/steps/fin-custom/data-type-select-item': typeof DataTypeSelectItem;
  }
}
